import SearchCampaignWizard from '@/components/google-ads/search/SearchCampaignWizard';
import { TRAFFIC_OBJECTIVE } from './trafficObjective';

/** NEW WEBSITE TRAFFIC CAMPAIGN — /google-ads/traffic/create/campaign */
export default function TrafficCampaignWizard() {
  return <SearchCampaignWizard objective={TRAFFIC_OBJECTIVE} />;
}
